import FormattedValue from './FormattedValue';
import { VolumeUnit } from '@fulcrum/lib';
import { VolumeFormatter } from '@trimble/utilities';
import { JSX } from 'solid-js';
import { BaseFormattedValueProps } from './base-formatted-value-props';
import { FormattingSettings } from '@trimble/types';

type Props = BaseFormattedValueProps<number, VolumeUnit, FormattingSettings>;

export const FormattedVolume = (props: Props): JSX.Element => {
  const toDisplay = (value: number): string =>
    VolumeFormatter.toDisplay({
      measuredValue: value,
      currentUnits: props.currentUnit,
      settings: props.settings,
    });

  return (
    <FormattedValue
      toDisplay={toDisplay}
      {...(props as Omit<Props, 'settings' | 'currentUnit'>)}
    />
  );
};
